import React, { Fragment } from 'react'
import propTypes from 'prop-types'
import Button from '../Button'
import "../../../styles/overwrittenAndNew/NewErrorModal.css"

const errorModal = ({
  size,
  center,
  msg,
  t,
  handleClose,
  className,
}) => (
  <Fragment>
    <div className={`custom-modal ${size} ${className} custom-error-modal center`}>
      <h4 className='error-modal-title'>{t('stock.adjustment.parameters.title')}</h4>
        {msg.split('\n').map((line, index) => (
          <p key={index} className={`${center && 'error-modal-description'}`}>
          {line}.
        </p>
        ))}

      <Button
        className='btn btn-primary error-modal-button'
        text={ t('stock.adjustment.parameters.try-again')}
        onClick={() => handleClose()}
      />
    </div>
    <div className='bg' onClick={() => handleClose()} />
  </Fragment>
)

errorModal.propTypes = {
  size: propTypes.string,
  handleClose: propTypes.func,
  msg: propTypes.string,
  t: propTypes.func,
  center: propTypes.bool,
  buttonText: propTypes.string,
  details: propTypes.string,
  className: propTypes.string,
}

export default errorModal
